import { useEffect, useState } from "react";
import { api, money } from "../lib/api";
import { Sparkle, ArrowsClockwise, Crown, Wallet } from "@phosphor-icons/react";
import { CustomerAvatar } from "./CustomerAvatar";

function typeBadge(count) {
  if (count >= 5) return { label: `Loyal · ${count} repairs`, Icon: Crown, cls: "bg-amber-50 border-amber-200 text-amber-700" };
  if (count >= 2) return { label: `Returning · ${count} repairs`, Icon: ArrowsClockwise, cls: "bg-[#EFF6FF] border-[#BFDBFE] text-[#1E5FEB]" };
  return { label: "New customer", Icon: Sparkle, cls: "bg-emerald-50 border-emerald-200 text-emerald-700" };
}

export function CustomerBadges({ t }) {
  const [info, setInfo] = useState(null);
  useEffect(() => {
    if (!t.customer_id) return setInfo(null);
    api.get(`/customers/${t.customer_id}/badge`).then((r) => setInfo(r.data)).catch(() => setInfo(null));
  }, [t.customer_id]);
  const type = info ? typeBadge(info.repair_count) : null;

  return (
    <div className="px-5 pt-5 pb-4 flex flex-wrap items-center gap-3" data-testid="customer-badges">
      <CustomerAvatar seed={t.customer_id || t.customer_name} size={44} testId="customer-initials-avatar" />
      {type && (
        <span className={`h-7 px-2.5 rounded-full border text-[11.5px] font-semibold inline-flex items-center gap-1.5 ${type.cls}`} data-testid="customer-type-badge">
          <type.Icon size={13} weight="bold" /> {type.label}
        </span>
      )}
      {info?.store_credit_balance > 0.005 && (
        <span className="h-7 px-2.5 rounded-full border border-emerald-200 bg-emerald-50 text-emerald-700 text-[11.5px] font-semibold inline-flex items-center gap-1.5" data-testid="customer-store-credit-badge">
          <Wallet size={13} weight="bold" /> ${money(info.store_credit_balance)} store credit
        </span>
      )}
      {!t.customer_id && <span className="text-[11.5px] text-slate-400" data-testid="customer-walkin-note">No customer profile linked</span>}
    </div>
  );
}
